import { render, staticRenderFns } from "./SeccionRitual.vue?vue&type=template&id=46aec48c&scoped=true"
import script from "./SeccionRitual.vue?vue&type=script&lang=js"
export * from "./SeccionRitual.vue?vue&type=script&lang=js"
import style0 from "./SeccionRitual.vue?vue&type=style&index=0&id=46aec48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aec48c",
  null
  
)

export default component.exports